import React from 'react';

import {
  Box,
  Typography
} from '@mui/material';
import { formatUtil } from 'modules';



interface IProps {
  total: number;
  raised: number;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Box display="flex">
      <Typography color="#528898">Raised&nbsp;</Typography>
      <Typography
        color="#E16B50"
        fontWeight={700}>
        {formatUtil.getDollarString(props.raised)}
      </Typography>

      <Typography color="#528898">&nbsp;/ {formatUtil.getDollarString(props.total)}</Typography>
    </Box>
  );
};
